module.exports = __webpack_public_path__ + "img/postcodenl-logo-blauw.72b64d29.png";